import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function NuotoAccPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <br/>
                            <h4  className="text-center" style={{fontFamily: "Hammersmith One", fontSize: "22px"}}>
                                CORSI BAMBINI/RAGAZZI
                            </h4>
                            <br/>
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One", maxWidth: "5em"}}></th>
                                    <th scope="col" style={{width: "43%"}}>
                                        Quadrimestre
                                    </th>
                                    <th scope="col" style={{width: "43%"}}>
                                        Stagione
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Acquaticità (6 - 36 mesi)</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}>288 €</td>
                                    <td className={"data-cell"}>444 €</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Avviamento (3 - 5 anni)</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}>270 €</td>
                                    <td className={"data-cell"}>481 €</td>
                                </tr>
                                <tr>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}>592 €</td>
                                    <td className={"data-cell"}>629 €</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Bambini/ragazzi (6 - 14 anni)</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}>270 €</td>
                                    <td className={"data-cell"}>407 €</td>
                                </tr>
                                <tr>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}>545 €</td>
                                    <td className={"data-cell"}>555 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                            <h4  className="text-center" style={{fontFamily: "Hammersmith One", fontSize: "22px"}}>
                                CORSI ADULTI
                            </h4>
                            <br/>
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >

                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "40%"}}>
                                        Quadrimestre
                                    </th>
                                    <th scope="col" style={{width: "40%"}}>
                                        Stagione
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Mattino/intervallo</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}>252 €</td>
                                    <td className={"data-cell"}>439 €</td>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}>481 €</td>
                                    <td className={"data-cell"}>555 €</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Sera</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}>270 €</td>
                                    <td className={"data-cell"}>481 €</td>
                                </tr>
                                <tr>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}>549 €</td>
                                    <td className={"data-cell"}>629 €</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Corso mattino/intervallo + nuoto libero</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>540 €</td>
                                </tr>
                                <tr>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>760 €</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={2}  scope="" style={{fontFamily: "Hammersmith One"}}>Corso sera + nuoto libero</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>Monosettimanale</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>590 €</td>
                                </tr>
                                <tr>
                                    <th scope="row" style={{fontSize: "14px"}}>Bisettimanale</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>829 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                            <h4  className="text-center" style={{fontFamily: "Hammersmith One", fontSize: "22px"}}>
                                PREAGONISTICA
                            </h4>
                            <br/>
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "50%"}}>
                                        Stagione
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row" style={{fontSize: "14px"}}>4 volte a settimana</th>
                                    <td className={"data-cell"}>950 €</td>
                                </tr>
                                </tbody>

                            </table>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NuotoAccPrezzi